import React from "react";
import styles from "../../../CSS/sections/AboutUsBanner.module.css";

const AboutUsBanner = ({ content }) => {
  const { title, description, image } = content;
  return (
    <section className={`${styles.aboutUsBanner} padding-y`}>
      <div className="container">
        <div className={`${styles.rowCustom} row`}>
          <div className="col-12 col-md-6">
            <h1 className={`mb-3 ${styles.heading1}`}>{title}</h1>
            <div className={styles.aboutUsContent}>
              {description &&
                description.map((para) => <p className="text-dark">{para}</p>)}
            </div>
          </div>
          <div className="col-12 col-md-6">
            <img src={image} alt="Rhino" className={styles.aboutUsRhino} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUsBanner;
